import React, { useEffect, useSyncExternalStore } from "react";
import { LoaderCircle } from "lucide-react";
import { LAYERS, T } from "../app/tokens.js";
import { CONFIRM_MS, MAX_PENDING_MS, subscribeFeedback, getFeedbackSnapshot,
  dismissFeedback, failFeedback, feedbackProgress } from "../services/devActAsFeedback.js";
import "./devActAsFeedback.css";

// Mounted outside the account popover and AppShell's auth guard.
export function DevActAsFeedback() {
  const { enabled, feedback } = useSyncExternalStore(subscribeFeedback, getFeedbackSnapshot);
  useEffect(() => {
    if (!enabled || !feedback || feedback.phase === "error") return undefined;
    const success = feedback.phase === "success";
    const timer = setTimeout(() => {
      if (success) dismissFeedback();
      else failFeedback(new Error("Profile loading timed out. Reload to check the current identity."));
    }, success ? CONFIRM_MS : Math.max(0, MAX_PENDING_MS - (Date.now() - feedback.at)));
    return () => clearTimeout(timer);
  }, [enabled, feedback]);
  if (!enabled || !feedback) return null;
  const pending = ["request", "reload"].includes(feedback.phase);
  return <div className="dev-act-as-feedback" data-testid="dev-act-as-feedback"
    style={{ zIndex: LAYERS.modal + 10, background: T.modalOverlay }}>
    <div className="dev-act-as-feedback-card" style={{ background: T.card, color: T.dark,
      border: `1px solid ${T.border}`, boxShadow: T.shadowModal, fontSize: T.fsBase }}>
      <div role={feedback.phase === "error" ? "alert" : "status"} aria-live="polite" aria-atomic="true">
        {pending && <LoaderCircle className="dev-act-as-feedback-spinner" aria-hidden="true" size={26} style={{ color: T.blue }} />}
        <span>{pending ? feedbackProgress(feedback) : feedback.message}</span>
      </div>
      {feedback.phase === "error" && <button type="button" autoFocus onClick={dismissFeedback}
        style={{ marginTop: 16, color: T.blue, border: `1px solid ${T.border}`, background: T.card,
          padding: "6px 12px", borderRadius: 6, cursor: "pointer" }}>Dismiss</button>}
    </div>
  </div>;
}
